// removed by extract-text-webpack-plugin
module.exports = {"loader":"CustomLoader_loader_13Sry","load1":"CustomLoader_load1_18Z47"};


//////////////////
// WEBPACK FOOTER
// ./src/docs/examples/Loader/CustomLoader.css
// module id = 40
// module chunks = 0